import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Table, Form, InputGroup, Pagination } from 'react-bootstrap';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import axios from 'axios';
import { BsSearch, BsSortDown, BsSortUp } from 'react-icons/bs';
import { API_ENDPOINTS } from '../config';  // Updated import

const Appointments = () => {
  const [appointments, setAppointments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [appointmentsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [sortField, setSortField] = useState('date');
  const [sortDirection, setSortDirection] = useState('asc');

  useEffect(() => {
    fetchAppointments();
  }, []);

  const fetchAppointments = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(API_ENDPOINTS.getAppointments, {  // Updated endpoint
        headers: {
          'token': token,
        }
      });
      setAppointments(response.data.appointments);
    } catch (error) {
      console.error('Error fetching appointments:', error);
    }
  };

  const sortAppointments = (field) => {
    if (field === sortField) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const sortedAndFilteredAppointments = appointments
    .filter(appointment =>
      appointment.bookingId.toLowerCase().includes(searchTerm.toLowerCase()) ||
      appointment.userID.toLowerCase().includes(searchTerm.toLowerCase()) ||
      appointment.providerID.toLowerCase().includes(searchTerm.toLowerCase()) ||
      appointment.date.toLowerCase().includes(searchTerm.toLowerCase()) ||
      appointment.time.toLowerCase().includes(searchTerm.toLowerCase()) ||
      appointment.fees.toString().includes(searchTerm.toLowerCase()) ||
      appointment.channelName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      appointment.status.toLowerCase().includes(searchTerm.toLowerCase()) ||
      appointment.userName.toLowerCase().includes(searchTerm.toLowerCase()) ||
      appointment.providerName.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => {
      if (a[sortField] < b[sortField]) return sortDirection === 'asc' ? -1 : 1;
      if (a[sortField] > b[sortField]) return sortDirection === 'asc' ? 1 : -1;
      return 0;
    });

  const indexOfLastAppointment = currentPage * appointmentsPerPage;
  const indexOfFirstAppointment = indexOfLastAppointment - appointmentsPerPage;
  const currentAppointments = sortedAndFilteredAppointments.slice(indexOfFirstAppointment, indexOfLastAppointment);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div className="d-flex">
      <Sidebar style={{ position: 'fixed', top: 0, bottom: 0, left: 0, width: '250px', zIndex: 1000 }} />
      <div style={{  width: 'calc(100%)', height: 'calc(100vh)', overflowY: 'auto' }}>
        <Header style={{ position: 'fixed', top: 0, left: '250px', width: 'calc(100% - 250px)', zIndex: 1000 }} />
        <Container fluid className="mt-3">
          <Row>
            <Col>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h2>Appointments</h2>
              </div>
              <InputGroup className="mb-3">
                <InputGroup.Text><BsSearch /></InputGroup.Text>
                <Form.Control
                  placeholder="Search appointments..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </InputGroup>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th onClick={() => sortAppointments('bookingId')}>
                      Booking ID {sortField === 'bookingId' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th onClick={() => sortAppointments('userID')}>
                      User ID {sortField === 'userID' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th onClick={() => sortAppointments('providerID')}>
                      Provider ID {sortField === 'providerID' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th onClick={() => sortAppointments('date')}>
                      Date {sortField === 'date' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th onClick={() => sortAppointments('time')}>
                      Time {sortField === 'time' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th onClick={() => sortAppointments('fees')}>
                      Fees {sortField === 'fees' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th onClick={() => sortAppointments('channelName')}>
                      Channel Name {sortField === 'channelName' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th onClick={() => sortAppointments('status')}>
                      Status {sortField === 'status' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th onClick={() => sortAppointments('userName')}>
                      User Name {sortField === 'userName' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                    <th onClick={() => sortAppointments('providerName')}>
                      Provider Name {sortField === 'providerName' && (sortDirection === 'asc' ? <BsSortUp /> : <BsSortDown />)}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentAppointments.map((appointment) => (
                    <tr key={appointment.bookingId}>
                      <td>{appointment.bookingId}</td>
                      <td>{appointment.userID}</td>
                      <td>{appointment.providerID}</td>
                      <td>{appointment.date}</td>
                      <td>{appointment.time}</td>
                      <td>{appointment.fees}</td>
                      <td>{appointment.channelName}</td>
                      <td>{appointment.status}</td>
                      <td>{appointment.userName}</td>
                      <td>{appointment.providerName}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <Pagination>
                {[...Array(Math.ceil(sortedAndFilteredAppointments.length / appointmentsPerPage)).keys()].map(number => (
                  <Pagination.Item key={number + 1} active={number + 1 === currentPage} onClick={() => paginate(number + 1)}>
                    {number + 1}
                  </Pagination.Item>
                ))}
              </Pagination>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default Appointments;
